import Link from 'next/link'
import parse from 'html-react-parser'

import Icon from '@/components/ui/icon'
import NavPrimaryDropdown from '@/components/nav/primary/NavPrimaryDropdown'

import { useDropdownPosition } from '@/hooks/useDropdownPosition'

const navItemClass = `
  flex
  w-full
  items-center
  justify-between

  text-17
  xl:text-15
  leading-normal
  text-left
  border-b-2
  border-transparent

  font-normal
  group

  l-up:relative
  l-up:hover:border-b-2
  l-up:hover:border-black

  l:flex-col
  l:border-b
  l:border-grey-300
  l:hover:border-grey-300
`

const linkTextClass = `
  w-full
  py-16
  l-up:text-center
  group-hover:font-bold
  group-hover:tracking-[-0.03rem]
`

export default function NavPrimaryItem({
  id,
  url,
  title,
  acf,
  active,
  setActive,
  mobileActive,
  setMobileActive,
  onClick = null,
}) {
  const hasChildren = acf?.menu_columns?.length ?? 0
  const overviewLink = acf?.overview_link
  const itemActive = active === id
  const menuItemRef = useDropdownPosition({ active: itemActive })

  const mobileActiveClass = mobileActive === id ? 'link-active' : ''
  const mobileArrowClass = mobileActive === id ? 'l:-rotate-0' : 'l:-rotate-90'

  // If the item has no children, render a simple link
  if (!hasChildren) {
    return (
      <Link
        href={url}
        key={id}
        prefetch={false}
        onMouseOver={() => setActive(id)}
        onMouseOut={() => setActive(null)}
        className={`${navItemClass} l:px-24`}
        onClick={onClick}>
        <span data-title={parse(title)} className={linkTextClass}>
          <span>{parse(title)}</span>
        </span>
      </Link>
    )
  }

  // If the item has children, render a dropdown
  return (
    <div
      ref={menuItemRef}
      key={id}
      onMouseOver={() => setActive(id)}
      onMouseOut={() => setActive(null)}
      className={`${mobileActiveClass} ${navItemClass}`}>
      <span className={`flex w-full items-center justify-between l:pl-24`}>
        <Link
          href={url}
          data-title={parse(title)}
          className={`${linkTextClass}`}
          prefetch={false}
          onClick={onClick}>
          <span>{parse(title)}</span>
        </Link>

        <button
          className="ml-xxxs shrink-0 l:block l:border-l l:px-20 l:py-16"
          onClick={() => {
            if (mobileActive !== id) {
              setMobileActive(id)
              return
            }

            setMobileActive(null)
          }}>
          <Icon
            id="icon-dropdown-arrow"
            className={`inline h-[6px] w-[12px] l:h-[12px] l:w-[12px] l:transform ${mobileArrowClass}`}
          />
        </button>
      </span>

      <NavPrimaryDropdown
        overviewLink={overviewLink}
        columns={acf.menu_columns}
        active={itemActive}
        onClick={onClick}
      />
    </div>
  )
}
